import axios from './api'
const customerServer = {
    getCustomerPageList(params) {
        return axios.post(`/org/customer/pageList`, params).then((res) => {
            return res.data
        })
    },

    getCusDetails(params) {
        return axios.get(`/org/customer/load`, { params: params }).then((res) => {
            return res.data
        })
    },

    getFollowPageList(params) {
        return axios.post(`/org/customerFollowUp/pageList`, params).then((res) => {
            return res.data
        })
    },

    addFollowUp(params) {
        return axios.post(`/org/customerFollowUp/save`, params).then((res) => {
            return res.data
        })
    },

    getChannelPageList(params) {
        return axios.post(`/org/system/pageList`, params).then((res) => {
            return res.data
        })
    },

    addCustomer(params) {
        return axios.post(`/org/customer/save`, params).then((res) => {
            return res.data
        })
    },

    getCusFlow(params) {
        return axios.get(`/org/customer/loadCustomerDistribution`, { params: params }).then((res) => {
            return res.data
        })
    },

    updateCusQualificationLabel(params) {
        return axios.post(`/org/customer/update/label`, params).then((res) => {
            return res.data
        })
    },

    updateCusBusinessStatus(params) {
        return axios.post(`/org/customer/update/business/status`, params).then((res) => {
            return res.data
        })
    },

    RedistributeCus(params) {
        return axios.post(`/org/customer/rematch/custom`, params).then((res) => {
            return res.data
        })
    },
}
export default customerServer


// WEBPACK FOOTER //
// ./src/api/customer.js